import Cookies from "js-cookie";

export default {
  install(Vue) {
    let authCookies = {};

    /**
     * Remove all tokens from cookie storage
     * @param {Object} authData object with token and refresh_token keys
     * @return {undefined}
     */
    authCookies.set = authData => {
      const { token, refresh_token: refreshToken } = authData;
      Cookies.set("token", token, { expires: 1 / 24 });
      const refreshTokenCookieExpiration = parseInt(
        process.env.VUE_APP_REFRESH_TOKEN_COOKIE_EXPIRATION
      );
      Cookies.set("refreshToken", refreshToken, {
        expires: refreshTokenCookieExpiration
      });
    };

    /**
     * Remove all tokens from cookie storage
     * @return {undefined}
     */
    authCookies.unset = () => {
      Cookies.remove("token");
      Cookies.remove("refreshToken");
    };

    // Make the plugin available to Vue
    Vue.prototype.$gwzAuthCookies = authCookies;
  }
};
